import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';

import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import LoadingAlert from '../Alerts/LoadingAlert';
import ErrorAlert from '../Alerts/ErrorAlert';

const ModalDetaillsEvent = ({eventDataState }) => {
    const [show, setShow] = useState(false)


    return (
        <>
            <div className="event-pill d-flex align-items-center px-3 py-1 rounded-pill shadow-sm" style={{ background: '#FFF7E6', border: '1px solid #f59e0b', color: '#b45309', fontWeight: 'bold', fontSize: '1rem', cursor: 'pointer', transition: 'box-shadow 0.2s' }} onClick={()=> setShow(true)}>
                <span className="me-2" style={{ width: 10, height: 10, background: '#f59e0b', borderRadius: '50%', display: 'inline-block' }}></span>
                <span style={{ fontWeight: 600 }}>Evento: {eventDataState.name}</span>
            </div>
            <Modal
                show={show}
                onHide={() => setShow(false)}
                centered
                dialogClassName="custom-modal-event"
            >
                <Modal.Header closeButton style={{ background: '#FFF7E6', borderBottom: '1px solid #f59e0b' }}>
                    <Modal.Title style={{ color: '#b45309', fontWeight: 'bold', fontSize: '1.3rem' }}>
                        <i className="uil uil-calendar-alt me-2" style={{ color: '#f59e0b' }}></i>
                        Detalle del evento
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ background: '#fff', padding: '2rem 1.5rem' }}>
                    <div className="mb-3 p-3 rounded shadow-sm" style={{ background: '#FFF7E6', border: '1px solid #f59e0b' }}>
                        <h4 className="mb-2" style={{ color: '#b45309', fontWeight: 'bold' }}>{eventDataState.name}</h4>
                        <p className="mb-1" style={{ color: '#6b7280' }}>{eventDataState.description}</p>
                        <div className="d-flex flex-wrap gap-3 mt-2">
                            <div className="d-flex align-items-center gap-2">
                                <i className="uil uil-check-circle" style={{ color: eventDataState.state === 1 ? '#22c55e' : '#ef4444' }}></i>
                                <span style={{ fontWeight: 500 }}>{eventDataState.state === 1 ? 'Activo' : 'Inactivo'}</span>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <i className="uil uil-calendar-alt" style={{ color: '#f59e0b' }}></i>
                                <span style={{ fontWeight: 500 }}>
                                    {eventDataState.dates && eventDataState.dates.length > 0 ? `${new Date(eventDataState.dates[0].initialDate).toLocaleDateString()} - ${new Date(eventDataState.dates[0].maxDate).toLocaleDateString()}` : 'Sin fecha'}
                                </span>
                            </div>
                        </div>
                        {eventDataState.dates && eventDataState.dates.length > 0 && (
                            <div className="mt-3">
                                <span className="badge bg-warning text-dark px-3 py-2" style={{ fontSize: '1rem', borderRadius: '1rem' }}>
                                    {eventDataState.dates[0].description}
                                </span>
                            </div>
                        )}
                        <div className="mt-3 d-flex flex-wrap gap-3">
                            <span className="badge bg-light text-secondary border" style={{ fontSize: '0.95rem' }}>ID evento: {eventDataState.id}</span>
                            <span className="badge bg-light text-secondary border" style={{ fontSize: '0.95rem' }}>ID fecha evento: {eventDataState.event_date_id}</span>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalDetaillsEvent